import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusUserSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EpocusUserSettingsQuery = { readonly __typename?: 'Query', readonly myUser?: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null, readonly telephone?: string | null, readonly consent: { readonly __typename?: 'UserPersonConsent', readonly whatsapp: boolean, readonly marketing: boolean } } | null } | null };

export type EpocusUpdateUserPersonalInfoMutationVariables = Types.Exact<{
  input: Types.UpdateUserInput;
}>;


export type EpocusUpdateUserPersonalInfoMutation = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null } | null } };

export type EpocusUpdateUserConsentMutationVariables = Types.Exact<{
  input: Types.UpdateUserInput;
}>;


export type EpocusUpdateUserConsentMutation = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly telephone?: string | null, readonly consent: { readonly __typename?: 'UserPersonConsent', readonly whatsapp: boolean, readonly marketing: boolean } } | null } };


export const EpocusUserSettingsDocument = gql`
    query EpocusUserSettings {
  myUser {
    _id
    person {
      firstname
      middlename
      lastname
      telephone
      consent {
        whatsapp
        marketing
      }
    }
  }
}
    `;

/**
 * __useEpocusUserSettingsQuery__
 *
 * To run a query within a React component, call `useEpocusUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpocusUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<EpocusUserSettingsQuery, EpocusUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusUserSettingsQuery, EpocusUserSettingsQueryVariables>(EpocusUserSettingsDocument, options);
      }
export function useEpocusUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusUserSettingsQuery, EpocusUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusUserSettingsQuery, EpocusUserSettingsQueryVariables>(EpocusUserSettingsDocument, options);
        }
export type EpocusUserSettingsQueryHookResult = ReturnType<typeof useEpocusUserSettingsQuery>;
export type EpocusUserSettingsLazyQueryHookResult = ReturnType<typeof useEpocusUserSettingsLazyQuery>;
export type EpocusUserSettingsQueryResult = Apollo.QueryResult<EpocusUserSettingsQuery, EpocusUserSettingsQueryVariables>;
export const EpocusUpdateUserPersonalInfoDocument = gql`
    mutation EpocusUpdateUserPersonalInfo($input: UpdateUserInput!) {
  updateUser(input: $input) {
    _id
    person {
      firstname
      middlename
      lastname
    }
  }
}
    `;
export type EpocusUpdateUserPersonalInfoMutationFn = Apollo.MutationFunction<EpocusUpdateUserPersonalInfoMutation, EpocusUpdateUserPersonalInfoMutationVariables>;

/**
 * __useEpocusUpdateUserPersonalInfoMutation__
 *
 * To run a mutation, you first call `useEpocusUpdateUserPersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusUpdateUserPersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusUpdateUserPersonalInfoMutation, { data, loading, error }] = useEpocusUpdateUserPersonalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusUpdateUserPersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<EpocusUpdateUserPersonalInfoMutation, EpocusUpdateUserPersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusUpdateUserPersonalInfoMutation, EpocusUpdateUserPersonalInfoMutationVariables>(EpocusUpdateUserPersonalInfoDocument, options);
      }
export type EpocusUpdateUserPersonalInfoMutationHookResult = ReturnType<typeof useEpocusUpdateUserPersonalInfoMutation>;
export type EpocusUpdateUserPersonalInfoMutationResult = Apollo.MutationResult<EpocusUpdateUserPersonalInfoMutation>;
export type EpocusUpdateUserPersonalInfoMutationOptions = Apollo.BaseMutationOptions<EpocusUpdateUserPersonalInfoMutation, EpocusUpdateUserPersonalInfoMutationVariables>;
export const EpocusUpdateUserConsentDocument = gql`
    mutation EpocusUpdateUserConsent($input: UpdateUserInput!) {
  updateUser(input: $input) {
    _id
    person {
      telephone
      consent {
        whatsapp
        marketing
      }
    }
  }
}
    `;
export type EpocusUpdateUserConsentMutationFn = Apollo.MutationFunction<EpocusUpdateUserConsentMutation, EpocusUpdateUserConsentMutationVariables>;

/**
 * __useEpocusUpdateUserConsentMutation__
 *
 * To run a mutation, you first call `useEpocusUpdateUserConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusUpdateUserConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusUpdateUserConsentMutation, { data, loading, error }] = useEpocusUpdateUserConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusUpdateUserConsentMutation(baseOptions?: Apollo.MutationHookOptions<EpocusUpdateUserConsentMutation, EpocusUpdateUserConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusUpdateUserConsentMutation, EpocusUpdateUserConsentMutationVariables>(EpocusUpdateUserConsentDocument, options);
      }
export type EpocusUpdateUserConsentMutationHookResult = ReturnType<typeof useEpocusUpdateUserConsentMutation>;
export type EpocusUpdateUserConsentMutationResult = Apollo.MutationResult<EpocusUpdateUserConsentMutation>;
export type EpocusUpdateUserConsentMutationOptions = Apollo.BaseMutationOptions<EpocusUpdateUserConsentMutation, EpocusUpdateUserConsentMutationVariables>;